import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Faq } from "@/utils/types/aem";
import { getFaqData } from "./actions";

const initialState = {
  isLoading: false,
  isError: false,
  faq: {} as Faq,
  itemsOrder: [] as any,
  breadcrumps: {} as any,
};

const GetFaqDataSlice = createSlice({
  name: "faqDataSlice",
  initialState,
  reducers: {
    setFaqData:(state,action: PayloadAction<any>)=>{

      state.isLoading = false;
      state.isError = false;
      state.faq =
        action.payload[":items"]["root"][":items"]["container"][":items"][
          "container"
        ][":items"]["accordion"];
      state.itemsOrder =
        action.payload[":items"]["root"][":items"]["container"][":items"][
          "container"
        ][":itemsOrder"];
      state.breadcrumps =
        action.payload[":items"]["root"][":items"][
          "experiencefragment-header"
        ][":items"]["root"][":items"]["breadcrumb"];

    }
  },
  extraReducers: (builder) => {
    builder.addCase(getFaqData.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(
      getFaqData.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isError = false;
        state.faq =
          action.payload[":items"]["root"][":items"]["container"][":items"][
            "container"
          ][":items"]["accordion"];
        state.itemsOrder =
          action.payload[":items"]["root"][":items"]["container"][":items"][
            "container"
          ][":itemsOrder"];
        state.breadcrumps =
          action.payload[":items"]["root"][":items"][
            "experiencefragment-header"
          ][":items"]["root"][":items"]["breadcrumb"];
      }
    );
    builder.addCase(getFaqData.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });
  },
});

export const {
  setFaqData
} = GetFaqDataSlice.actions;

export const getFaqDataSlice = GetFaqDataSlice.reducer;